import Vue from 'vue'
import Router from 'vue-router'
import index from '@/components/index'
import login from '@/components/login'
import success from '@/components/success'
import fail from '@/components/fail'
import cancel from '@/components/cancel'
import asks from '@/components/asks'
import email from '@/components/email'

Vue.use(Router)

export default new Router({
 /* mode: 'history',
  base: '/#', // newPay1基础路径 */
  routes: [
    {
      path: '/',
      name: 'index',
      component: index
    },
    {
      path: '/login',
      name: 'login',
      component: login
    },
    {
      path: '/success',
      name: 'success',
      component: success
    },
    {
      path: '/fail',
      name: 'fail',
      component: fail
    },
    {
      path: '/cancel',
      name: 'cancel',
      component: cancel
    },
    {
      path: '/asks',
      name: 'asks',
      component: asks
    },
    {
      path: '/email',
      name: 'email',
      component: email
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js